import countries from 'i18n-iso-countries'
import { useMemo } from 'react'
import { useParams } from 'react-router'

import { AppLocale } from '@procsea/common/utils'

import { LocaleParams } from 'src/types'

export const getCountriesSelectOptions = (locale: AppLocale) =>
  Object.entries(countries.getAlpha2Codes()).map(([key]) => ({
    label: countries.getName(key, locale) || '',
    value: key,
  }))

const useCountryOptions = () => {
  const { locale } = useParams<LocaleParams>()

  const countriesSelectOptions = useMemo(() => getCountriesSelectOptions(locale), [locale])

  return countriesSelectOptions
}

export default useCountryOptions
